import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { AuthenticationService } from "src/app/core/services/auth.service";
import { Categories } from "../../../core/models/categories.enum";

@Component({
  selector: "app-mobility-benefit-accordion",
  templateUrl: "./mobility-benefit-accordion.component.html",
  styleUrls: ["./mobility-benefit-accordion.component.scss"],
})
export class MobilityBenefitAccordionComponent implements OnChanges, OnInit {
  @Input() benefits;
  selectedChoiceNine: string;
  selectedChoiceTen: string;
  planControl = new FormControl();
  isDisabled = true;
  response: any;

  constructor(private authService: AuthenticationService) {}
  employeeId;
  benefitDescription: string;
  discountValue: string;
  hiringProcessId;
  benefitsValue$: Observable<any>;
  benefit: any;
  discount: string;
  selectedPlanName: any;
  plans: any[] = [];
  selectedChoice: string;
  selectedPlan: any;

  ngOnInit(): void {
    this.employeeId = this.authService.currentUser().payload.employeeId;
    // this.getEmployeesHiring();
    this.planControl.disable();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.getBenefits(changes?.benefits?.currentValue);
  }
  // getEmployeesHiring() {
  //   this.employeesHiringService
  //     .getEmployeesHiring(this.employeeId)
  //     .subscribe((res: any) => {
  //       const id = res.hiringProcessId;
  //       this.hiringProcessId = id;

  //       this.getBenefits(id);
  //     });
  // }

  setBenefitChoice(): void {
    this.benefit.items?.forEach((item) => (item.selected = false));

    const plan = this.benefit.items?.find(
      (item) => item.index == this.selectedPlan.index
    );

    plan.selected = this.benefit.wantTheBenefit;
  }

  onPlanChange(event: any): void {
    this.selectedPlanName = event;
  }

  getBenefits(benefits?: any) {
    if (!benefits) return;
    // this.benefitsService.getBenefits(id).subscribe(
    // (response: any) => {
    this.response = benefits;
    if (this.response.benefitTypes && this.response.benefitTypes.length > 0) {
      for (const type of this.response.benefitTypes) {
        const foundBenefit = type.benefitList.find(
          (benefit) => benefit.categoryId === Categories.PCD //"Beneficio Mobilidade"
        );
        if (foundBenefit) {
          this.benefit = foundBenefit;
          this.discountValue = foundBenefit.holderDiscount;
          this.discount = foundBenefit.existDiscountToHolder;
          // if (
          //   foundBenefit.wantTheBenefit &&
          //   foundBenefit.item &&
          //   foundBenefit.item.index
          // ) {
          this.selectedPlan = this.benefit.items?.find((plan) => plan.selected);

          break;
        }
      }
    }
    //   },
    //   (error) => {
    //     console.error(
    //       "Error fetching benefits:",
    //       error.message || JSON.stringify(error)
    //     );
    //   }
    // );
  }
}
